module.exports = __webpack_public_path__ + "res/26-img_bg_l.be3757a4073a0b95037fdf0d73607b23.png";